<template>
  <section class="app-main">
    <transition mode="out-in" name="fade-transform">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  data() {
    return {
    };
  },

  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.path;
    }
  },

  created() {
  },

  methods: {

  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';

.app-main {
  height: calc(100vh - #{$layoutHeaderTotalHeight});
  width: 100%;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 18px 20px 20px;
  background: #f7f8fa;
  scroll-behavior: smooth;
}

.fixed-header + .app-main {
  height: 100vh;
  padding-top: calc(#{$layoutHeaderTotalHeight} + 22px);
}

@media (max-width: 768px) {
  .app-main {
    padding: 12px;
  }

  .fixed-header + .app-main {
    padding-top: calc(#{$layoutHeaderTotalHeight} + 16px);
  }
}

.im {
  position: fixed;
  right: 0;
  bottom: 10px;
  /* border: 1px solid red; */
  z-index: 500;
}
</style>

<style lang="scss">
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}

</style>
